import store from "@/store"

const onlyAdmin = (to, from, next) => {

  if (store.state.user.isAdministrator) {
    next()
  } else {
    next("/notfound")
  }
}

const onlyNonCustomers = (to, from, next) => {
  
  if (!store.state.user.isProspect && !store.state.user.isCustomer) {
    next()
  } else {
    next("/notfound")
  }
}

const guards = {
  onlyAdmin,
  onlyNonCustomers,
}

export default guards